export function farloUiTimelineCarousel(element) {

    let flktyTimeline = new Flickity(element, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        wrapAround: false,
        freeScroll: true,
        draggable: true,
        dragThreshold: 5,
    });

    const onWheel = (event) => {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
            event.preventDefault();

            if (event.deltaX < 0) {
                flktyTimeline.previous();
            } else {
                flktyTimeline.next();
            }
        }
    };

    element.addEventListener('wheel', onWheel);
}
